var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 39C32.732 39 39 32.732 39 25C39 17.268 32.732 11 25 11C17.268 11 11 17.268 11 25C11 32.732 17.268 39 25 39ZM25 33C29.4183 33 33 29.4183 33 25C33 20.5817 29.4183 17 25 17C20.5817 17 17 20.5817 17 25C17 29.4183 20.5817 33 25 33Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17C26.6569 17 28 15.6569 28 14C28 12.3431 26.6569 11 25 11C23.3431 11 22 12.3431 22 14C22 15.6569 23.3431 17 25 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.2478e62ce9e07c191d283e2f86eeffcc.svg";
export { ForwardRef as ReactComponent };